import posthog from 'posthog-js'
import { PostHogProvider as PHProvider } from 'posthog-js/react'

const apiKey =
  process.env.NEXT_PUBLIC_VERCEL_ENV === 'production'
    ? process.env.NEXT_PUBLIC_POSTHOG_PRODUCTION_KEY
    : process.env.NEXT_PUBLIC_POSTHOG_DEVELOPMENT_KEY

// Check that PostHog is client-side (used to handle Next.js SSR)
if (typeof window !== 'undefined') {
  posthog.init(apiKey!, {
    api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST || 'https://us.i.posthog.com',
    person_profiles: 'identified_only',
    autocapture: false,
    // Enable debug mode in development
    loaded: (posthog) => {
      if (process.env.NODE_ENV === 'development') posthog.debug()
    },
  })
}

export const PostHogProvider = ({ children }: { children: React.ReactNode }) => {
  return <PHProvider client={posthog}>{children}</PHProvider>
}
